"use client";

import { Notification } from "@/types/notification";
import NotificationItem, {
  NotificationAvatar,
  NotificationPageLink,
  NotificationWorkspaceLink,
} from "@/components/tailwind/notification/notificationItem";
import { useWorkspaceContext } from "@/contexts/workspaceContext";

interface NotificationAssignProps {
  notification: Notification;
}

export default function NotificationAssign({ notification }: NotificationAssignProps) {
  const { getMemberName } = useWorkspaceContext();
  const displayName = getMemberName(notification.createdBy?.userId) || getMemberName(notification.createdBy?.userEmail) || notification.createdBy?.userName || "System";

  return (
    <NotificationItem
      icon={<NotificationAvatar name={displayName} userId={notification.createdBy?.userId} email={notification.createdBy?.userEmail} />}
      createdAt={notification.createdAt}
      unread={!notification.read}
      title={displayName}
      message={
        <>
          Assigned you to{" "}
          <NotificationPageLink
            noteId={notification.noteId}
            title={notification.noteTitle || "New page"}
          />{" "}
          in{" "}
          <NotificationWorkspaceLink
            workspaceId={notification.workspaceId}
            workspaceName={notification.workspaceName}
          />
        </>
      }
    />
  );
}
